<template>
  <div>
    <div
      style="position: fixed; top: 0; left: 0; right: 0; z-index: 999"
      class="payment"
    >
      <van-nav-bar title="合同详情" @click-left="goBack" left-arrow>
      </van-nav-bar>
    </div>

    <div style="padding-top: 46px">
      <div class="info-title">基本信息（只读）</div>

      <div
        class="form-info-panel"
        style="padding-left: 0.4rem; text-align: left"
      >
        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">内部合同号</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">{{ info.bill_no }}</div>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">内部状态</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">{{ info.status_txt }}</div>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">合同号</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">{{ info.contract_numbe }}</div>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">合同状态</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">{{ info.contract_state_txt }}</div>
          </div>
        </div>

        <div class="barrie-line" v-if="info.contract_insurance_batch_need_apply"></div>

        <div class="cus-row cus-row-v-m" v-if="info.contract_insurance_batch_need_apply">
          <div class="cus-row-col-4">
            <span class="input-tag">保险状态</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">{{ info.contract_insurance_status_txt }}</div>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">业务员</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">
              {{ info.staff ? info.staff.name : "" }}
            </div>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">创建时间</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">{{ info.created_at }}</div>
          </div>
        </div>
      </div>

      <div class="info-title">产品信息和费用</div>

      <div
        class="form-info-panel"
        style="padding-left: 0.4rem; text-align: left"
      >
        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">模板类型</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <select
              v-model="contract_type"
              style="padding: 0"
              class="line-select"
              disabled
              onfocus="this.blur()"
            >
              <option value="A00001">境内游</option>
              <option value="C00001">出境游</option>
              <option value="F00001">赴台游</option>
              <option value="E00001">代订代办</option>
            </select>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">线路名称</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <input
              class="line-input"
              placeholder="必填"
              v-model="contract_name"
            />
          </div>
        </div>

        <div v-if="contract_type == 'A00001' || contract_type == 'C00001'">
          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">出发日期</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                type="text"
                style=""
                placeholder="必填"
                readonly
                onfocus="this.blur()"
                :value="
                  $refs.begin_time_select ? $refs.begin_time_select.dateStr : ''
                "
                @click="$refs.begin_time_select.doSelect()"
              />
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">结束日期</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                type="text"
                style=""
                placeholder="必填"
                readonly
                onfocus="this.blur()"
                :value="
                  $refs.end_time_select ? $refs.end_time_select.dateStr : ''
                "
                @click="$refs.end_time_select.doSelect()"
              />
            </div>
          </div>

          <div class="barrie-line"></div>

          <!-- 出发时间 -->
          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">出发时间</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <select
                v-model="contract_begin_time"
                style="padding: 0"
                :class="['line-select', { 'placeholder-color': contract_begin_time === ''  }]"
                placeholder="非必填，默认09:00"
              >

              <option value="" disabled selected hidden>非必填，默认9:00</option>
                <option v-for="hour in 25" :key="hour - 1" :value="hour - 1">
                  {{ hour - 1 }}:00
                </option>
              </select>
            </div>
          </div>

          <div class="barrie-line"></div>

          <!-- 结束时间 -->
          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">结束时间</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <select
                v-model="contract_end_time"
                style="padding: 0"
                :class="['line-select', { 'placeholder-color': contract_end_time === '' }]"
                placeholder="非必填，默认18:00"
              >
              <option value="" disabled selected hidden>非必填，默认18:00</option>
                <option v-for="hour in 25" :key="hour - 1" :value="hour - 1">
                  {{ hour - 1 }}:00
                </option>
              </select>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">共</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                style=""
                placeholder="必填"
                v-model="contract_days"
                type="number"
              />
              <div class="suffix-wrapper">日</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">饭店住宿</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                style=""
                placeholder="必填"
                v-model="contract_nights"
                type="number"
              />
              <div class="suffix-wrapper">夜</div>
            </div>
          </div>
         
          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4"><span class="input-tag">成人</span></div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_adult_price"
                type="number"
              />

              <div class="suffix-wrapper">元/人</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">儿童(不满14)</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_child_price"
                type="number"
              />

              <div class="suffix-wrapper">元/人</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">导游服务费</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_service_price"
                type="number"
              />

              <div class="suffix-wrapper">元/人</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">单房差</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_single_price"
                type="number"
              />

              <div class="suffix-wrapper">元/人</div>
            </div>
          </div>

        </div>


<div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">成人人数</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_adult_count"
                type="number"
              />

              <div class="suffix-wrapper">人</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">儿童人数</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="非必填"
                v-model="contract_child_count"
                type="number"
              />

              <div class="suffix-wrapper">人</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">旅游费用合计</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="非必填"
                v-model="contract_price"
                type="number"
              />

              <div class="suffix-wrapper">元</div>
            </div>
          </div>

        </div>


<div v-if="contract_type == 'A00001' || contract_type == 'C00001'">

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">支付方式</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <!-- <input
              class="line-input"
              placeholder="非必填"
              v-model="bank_account"
            /> -->
              <select
                v-model="contract_payway"
                style="padding: 0"
                class="line-select"
              >
                <!-- <option value="1">现金</option> -->
                <option value="2">对公转账</option>
                <option value="3">线上支付</option>
              </select>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">支付时间</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <!-- <input
              class="line-input"
              placeholder="非必填"
              v-model="bank_account"
            /> -->
              <input
                class="line-input"
                type="text"
                style=""
                placeholder="必填"
                readonly
                onfocus="this.blur()"
                :value="
                  $refs.pay_time_select ? $refs.pay_time_select.dateStr : ''
                "
                @click="$refs.pay_time_select.doSelect()"
              />
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">其他约定事项</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="非必填"
                v-model="contract_pay_remark"
              />
            </div>
          </div>
          <div style="font-size: 12px; line-height: 18px; opacity: 0.6">
            注：未尽事宜，旅游者和旅行社双方协商一致，可列入补充条款。（如合同空间不够，可另附纸张上传附件）
          </div>
        </div>
      </div>

      <div class="info-title">游客代表和游客信息</div>

      <div class="form-info-panel" style="padding: 0.4rem; text-align: left">
        <div
          v-for="(item, index) in course_data"
          :key="index"
          style="padding-bottom: 24px"
          @click="editPerson(item, index)"
        >
          <div style="position: relative">
            <div style="font-size: 14px; font-weight: bold">
              {{ item.name ? item.name : "??" }}
              <span
                v-if="item.isSigner == '1'"
                style="display: inline-block; margin-left: 6px; padding: 0 6px; line-height: 18px; height: 18px; font-size: 12px; color: #fff; background: #ff5722; border-radius: 9px; vertical-align: middle;"
              >签约人</span>
            </div>
            <div style="font-size: 12px; margin-top: 6px">
              {{ cardtypeTxt(item.cardtype) }}：{{ item.idcard }}
            </div>

            <div
              style="
                position: absolute;
                right: 0;
                font-size: 22px !important;
                top: 50%;
                transform: translateY(-50%);
                color: #1889f9 !important;
              "
            >
              <van-icon
                name="edit"
                style="
                  display: inline-block;
                  vertical-align: middle;
                  font-size: 22px !important;
                  color: #1889f9 !important;
                "
              />
            </div>
          </div>
        </div>

        <a
          style="
            display: inline-block;
            width: 100%;
            border-radius: 0.125rem;
            line-height: 0.7rem;
            font-family: PingFangSC-Regular;
            font-size: 0.3rem;
            color: #1889f9;
            border: 1px solid #9f9f9f;
            text-align: center;
          "
          href="javascript:void(0);"
          v-on:click="addCourse"
          v-bind:class="{ inEdit: !nextStepValid }"
        >
          <van-icon
            name="add-o"
            style="
              display: inline-block;
              margin-right: 6px;
              vertical-align: middle;
            "
          />
          <span style="display: inline-block; vertical-align: middle"
            >添加游客</span
          >
        </a>
      </div>

      <div class="info-title">自愿购物及增加景点活动</div>

      <div class="form-info-panel" style="padding: 0.4rem; text-align: left">
        <div
          v-for="(item, index) in shoppings"
          :key="index"
          style="padding-bottom: 24px"
          @click="editShopping(item, index)"
        >
          <div style="position: relative">
            <div style="font-size: 14px; font-weight: bold">
              {{ item.date || '未设置日期' }} · {{ item.shoppingPlace || '未设置购物地点' }}
            </div>
            <div style="font-size: 12px; margin-top: 6px">
              地点：{{ item.place || '-' }} / 商品：{{ item.goods || '-' }} / 停留：{{ item.stayDuration || '-' }} 分钟
            </div>

            <div
              style="position: absolute; right: 0; font-size: 22px !important; top: 50%; transform: translateY(-50%); color: #1889f9 !important;"
            >
              <van-icon name="edit" style="display: inline-block; vertical-align: middle; font-size: 22px !important; color: #1889f9 !important;" />
            </div>
          </div>
        </div>

        <a
          style="display: inline-block; width: 100%; border-radius: 0.125rem; line-height: 0.7rem; font-family: PingFangSC-Regular; font-size: 0.3rem; color: #1889f9; border: 1px solid #9f9f9f; text-align: center;"
          href="javascript:void(0);"
          v-on:click="addShopping"
          v-bind:class="{ inEdit: !nextStepValid }"
        >
          <van-icon name="add-o" style="display: inline-block; margin-right: 6px; vertical-align: middle;" />
          <span style="display: inline-block; vertical-align: middle">添加购物</span>
        </a>
      </div>

      <div v-if="contract_type == 'E00001'">
        <!-- <div class="info-title">机票预定</div>

        <div class="form-info-panel" style="padding: 0.4rem; text-align: left">
          <div
            v-for="(item, index) in course_data"
            :key="index"
            style="padding-bottom: 24px"
            @click="editPerson(item, index)"
          >
            <div style="position: relative">
              <div style="font-size: 14px; font-weight: bold">
                {{ item.name ? item.name : "??" }}
              </div>
              <div style="font-size: 12px; margin-top: 6px">
                {{ cardtypeTxt(item.cardtype) }}：{{ item.idcard }}
              </div>

              <div
                style="
                  position: absolute;
                  right: 0;
                  font-size: 22px !important;
                  top: 50%;
                  transform: translateY(-50%);
                  color: #1889f9 !important;
                "
              >
                <van-icon
                  name="edit"
                  style="
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 22px !important;
                    color: #1889f9 !important;
                  "
                />
              </div>
            </div>
          </div>

          <a
            style="
              display: inline-block;
              width: 100%;
              border-radius: 0.125rem;
              line-height: 0.7rem;
              font-family: PingFangSC-Regular;
              font-size: 0.3rem;
              color: #1889f9;
              border: 1px solid #9f9f9f;
              text-align: center;
            "
            href="javascript:void(0);"
            v-on:click="addCourse"
            v-bind:class="{ inEdit: !nextStepValid }"
          >
            <van-icon
              name="add-o"
              style="
                display: inline-block;
                margin-right: 6px;
                vertical-align: middle;
              "
            />
            <span style="display: inline-block; vertical-align: middle"
              >添加游客</span
            >
          </a>
        </div> -->

        <serviceitem ref="plane" title="机票预定" type="1"> </serviceitem>

        <serviceitem ref="hotel" title="酒店预定" type="2"> </serviceitem>

        <serviceitem ref="car" title="用车服务" type="3"> </serviceitem>

        <serviceitem ref="dao" title="导游服务" type="4"> </serviceitem>

        <serviceitem ref="visa" title="签证服务" type="5"> </serviceitem>

        <serviceitem ref="other" title="其他" type="6"> </serviceitem>


        <serviceitem ref="rule" title="通用条款" type="7"> </serviceitem>


        <!-- <serviceitem ref="other"  title="">

        </serviceitem> -->
      </div>

      <!-- 地接社信息 -->
      <div class="info-title" v-if="contract_type != 'E00001'">地接社信息（非必填）</div>
      <div
        class="form-info-panel"
        style="padding-left: 0.4rem; text-align: left"
        v-if="contract_type != 'E00001'"
      >
        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">地接社名称</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <input
              class="line-input"
              placeholder="请输入地接社名称"
              v-model="local_travel_agency.agency_name"
            />
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">具体地址</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <input
              class="line-input"
              placeholder="请输入具体地址"
              v-model="local_travel_agency.agency_address_description"
            />
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">联系人姓名</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <input
              class="line-input"
              placeholder="请输入联系人姓名"
              v-model="local_travel_agency.contact_name"
            />
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">联系人电话</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <input
              class="line-input"
              placeholder="请输入联系人电话"
              v-model="local_travel_agency.contact_phone"
              type="tel"
            />
          </div>
        </div>
      </div>

      <div v-if="contract_type == 'A00001' || contract_type == 'C00001'">
        <div class="info-title">其它约定信息</div>

        <div
          class="form-info-panel"
          style="padding-left: 0.4rem; text-align: left"
        >
          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">意外伤害保险</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <select
                v-model="contract_insurance_method"
                style="padding: 0"
                class="line-select"
                placeholder="必选"
                @change="onInsuranceMethodChange"
              >
                <option value="1">委托购买</option>
                <option value="2">自行购买</option>
              </select>
            </div>
          </div>

          <div class="barrie-line" v-if="contract_insurance_method == '1'"></div>

          <!-- 委托方式选择 -->
          <div class="cus-row cus-row-v-m" v-if="contract_insurance_method == '1'">
            <div class="cus-row-col-4">
              <span class="input-tag">委托方式</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <select
                v-model="contract_entrust_type"
                style="padding: 0"
                class="line-select"
                placeholder="必选"
                @change="onEntrustTypeChange"
              >
                <option value="1">手动委托</option>
                <option value="2">自动委托</option>
              </select>
            </div>
          </div>

          <div class="barrie-line" v-if="contract_insurance_method == '1'"></div>

          <!-- 手动委托：保险产品名称输入 -->
          <div class="cus-row cus-row-v-m" v-if="contract_insurance_method == '1' && contract_entrust_type == '1'">
            <div class="cus-row-col-4">
              <span class="input-tag">保险产品名称</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="请输入保险产品名称"
                v-model="contract_insurance_productname"
              />
            </div>
          </div>

          <!-- 自动委托：选择保险产品 -->
          <template v-if="contract_insurance_method == '1' && contract_entrust_type == '2'">
            <div class="cus-row cus-row-v-m">
              <div class="cus-row-col-4">
                <span class="input-tag">选择保险产品</span>
              </div>
              <div class="cus-row-col-8 select-line" @click="openProductPopup">
                <div
                  class="product-selector"
                  :class="{ 'has-value': selectedPlanCode, 'is-disabled': !insuranceDisclaimerAgreed }"
                >
                  <span v-if="displayProductName" class="selected-product">
                    {{ displayProductName }}
                  </span>
                  <span v-else class="placeholder">请选择保险产品</span>
                  <van-icon name="arrow" class="arrow-icon" />
                </div>
              </div>
            </div>
            <div class="insurance-disclaimer-wrap">
              <label class="insurance-disclaimer-label">
                <input
                  type="checkbox"
                  class="insurance-disclaimer-checkbox"
                  v-model="insuranceDisclaimerAgreed"
                  @change="onInsuranceDisclaimerChange"
                />
                <span class="insurance-disclaimer-text">{{ insuranceDisclaimerText }}</span>
              </label>
            </div>
          </template>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">最低成团人数</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_group_min_count"
              />
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">不成团约定</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <select
                v-model="contract_group_way"
                style="padding: 0"
                class="line-select"
                placeholder="必选"
              >
                <!-- <option disabled value="">请选择</option> -->
                <option value="1">委托其它旅行社</option>
                <option value="2">延期出团</option>
                <option value="3">改签其他线路出团</option>
                <option value="4">解除合同</option>
              </select>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">委托社名称</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="非必填"
                v-model="contract_group_othername"
              />
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">拼团约定</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <select
                v-model="contract_group_agree"
                style="padding: 0"
                class="line-select"
                placeholder="必填"
              >
                <option value="1">同意</option>
                <option value="2">不同意</option>
              </select>
            </div>
          </div>

          <!-- <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">争议解决方式</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <select
                v-model="contract_dispute_way"
                style="padding: 0"
                class="line-select"
                placeholder="必选"
              >
              
                <option value="1">仲裁</option>
                <option value="2">依法向人民法院起诉</option>
              </select>
            </div>
          </div> -->

          <!-- <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">仲裁庭名称</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="非必填"
                v-model="contract_dispute_tribunalname"
              />
            </div>
          </div> -->
        </div>
      </div>

      <div v-if="contract_type == 'A00001' || contract_type == 'C00001'">
        <div class="info-title">行程及附件上传</div>

        <div class="form-info-panel" style="padding: 0.4rem; text-align: left">
          <div v-for="(item, index) in fileList" :key="item" style="padding-bottom: 24px">
            <div style="position: relative">
              <div style="font-size: 14px; font-weight: bold">
                {{ getFileNameFromUrl(item) }}
              </div>
              <div style="font-size: 12px; margin-top: 6px">
                上传类型：{{ isPdfUrl(item) ? "pdf" : "docx" }}
              </div>
              <div style="font-size: 12px; margin-top: 6px">
                <FileSizeCheck :url="item" :limit="8" />
              </div>

              <div
                style="
                  position: absolute;
                  right: 0;
                  font-size: 22px !important;
                  top: 50%;
                  transform: translateY(-50%);
                  color: #1889f9 !important;
                "
                @click.stop="deleteFile(item, index)"
              >
                <van-icon
                  name="delete"
                  style="
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 22px !important;
                    color: #1889f9 !important;
                  "
                />
              </div>
            </div>
          </div>

          <a
            style="
              display: inline-block;
              width: 100%;
              border-radius: 0.125rem;
              line-height: 0.7rem;
              font-family: PingFangSC-Regular;
              font-size: 0.3rem;
              color: #1889f9;
              border: 1px solid #9f9f9f;
              text-align: center;
              position: relative;
            "
            href="javascript:void(0);"
            v-bind:class="{ inEdit: !nextStepValid }"
          >
            <van-icon
              name="add-o"
              style="
                display: inline-block;
                margin-right: 6px;
                vertical-align: middle;
              "
            />
            <span style="display: inline-block; vertical-align: middle"
              >添加文件</span
            >

            <input
              type="file"
              style="
                position: absolute;
                z-index: 999;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                opacity: 0;
              "
              accept="application/pdf,.docx"
              @change="getFile"
              ref="upload"
            />
          </a>
        </div>

        <div
          class="ps-text"
          style="padding: 0.2rem; text-align: left; opacity: 0.7"
        >
          注：只支持.pdf,.docx格式的文件。
        </div>
      </div>


  


      <div
        class="in-bl-line"
        style="padding: 0 0.5rem; margin-top: 0.5rem;"
        v-if="info.status == 1"
      >
        <a
          class="bt"
          href="javascript:void(0);"
          v-on:click="submitContract"
          v-bind:class="{ inEdit: !nextStepValid }"
          >提交合同</a
        >
      </div>


      <div
        class="in-bl-line"
        style="padding: 0 0.5rem; margin-top: 0.5rem; margin-bottom: 2rem"
        v-if="info.status == 1"
      >
        <a
          class="bt"
          href="javascript:void(0);"
          v-on:click="doPreview"
          v-bind:class="{ inEdit: !nextStepValid }"
          style="background-color: #ffffff; color: #1889f9; border: 1px solid #1889f9;"
          >预览合同</a
        >
       
      </div> 




      

      <div style="height: 200px;">

      </div>

    </div>

    <!-- <form style="display: none" id="data-form">
      <input
        id="fileTarget"
        ref="filElem"
        type="file"
        name="file"
        style="display: none"
        accept="image/gif,image/jpeg,image/png"
        @change="getFile"
      />
    </form> -->

    <CusDatePicker
      ref="begin_time_select"
      v-model="contract_begin_day"
    ></CusDatePicker>
    <CusDatePicker
      ref="end_time_select"
      v-model="contract_end_day"
    ></CusDatePicker>
    <CusDatePicker
      ref="pay_time_select"
      v-model="contract_pay_day"
    ></CusDatePicker>

    <!-- 购物日期选择器 -->
    <CusDatePicker
      ref="shopping_date_select"
      v-model="current_shopping.date"
    ></CusDatePicker>

    <van-image-preview v-model="show" :images="images" @change="onChange">
    </van-image-preview>

    <div style="position: fixed; bottom: 128px; right: 24px" @click="saveDraft">
      <div
        style="
          background-color: rgb(239, 239, 239);
          width: 40px;
          height: 40px;
          border-radius: 100%;
          position: relative;
        "
      >
        <img
          src="~@/assets/images/save_draft.png"
          class="ab-t-t-x-y"
          style="width: 20px; height: 20px"
        />
      </div>
    </div>

    <div style="position: fixed; bottom: 78px; right: 24px" @click="showMore">
      <div
        style="
          background-color: rgb(239, 239, 239);
          width: 40px;
          height: 40px;
          border-radius: 100%;
          position: relative;
        "
      >
        <img
          src="~@/assets/images/more.png"
          class="ab-t-t-x-y"
          style="width: 20px; height: 20px"
        />
      </div>
    </div>

    <!-- start of 游客编辑 -->
    <van-popup
      v-model="person_show"
      position="right"
      style="width: 82%; height: 100%; background: #f5f5f5; z-index: 99999"
    >
      <!--字符、注册年限、组合类型、注册类型、年限进行筛选-->

      <div
        style="
          box-shadow: 0px 2px 5px #eeeeee;
          background: #ffffff;
          margin-top: 2px;
        "
      >
        <van-cell title="" is-link value="关闭" @click="person_show = false" />
      </div>

      <!--用tab操作-->
      <div style="overflow-y: scroll; height: calc(100% - 90px)">
        <div style="padding: 12px">
          <van-form>
            <van-field
              name="checkboxGroup"
              label="姓名"
              v-model="current_person.name"
            >
            </van-field>
            <!-- 
            <van-field name="radio" label="证件类型">
                
            </van-field> -->

            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>证件类型</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body">
                  <!-- <input type="text" name="radio" class="van-field__control" /> -->
                  <select
                    v-model="current_person.cardtype"
                    style="padding: 0"
                    class="line-select"
                  >
                    <option value="1">身份证</option>
                    <option value="4">护照</option>
                    <option value="6">回乡证</option>
                    <option value="8">其他</option>
                  </select>
                </div>
              </div>
            </div>

            <van-field
              name="checkboxGroup"
              label="证件号"
              v-model="current_person.idcard"
            >
            </van-field>

            <!-- 出生日期（非必填，用于非身份证投保） -->
            <van-field
              name="birthday"
              label="出生日期"
              v-model="current_person.birthday"
              placeholder="非必填(例:19991201)"
              @blur="formatBirthdayInput"
            >
            </van-field>

            <!-- 性别（非必填，男/女） -->
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>性别</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body">
                  <select
                    v-model="current_person.gender"
                    style="padding: 0"
                    class="line-select"
                  >
                    <option value=""></option>
                    <option value="男">男</option>
                    <option value="女">女</option>
                  </select>
                </div>
              </div>
            </div>

            <van-field
              name="checkboxGroup"
              label="手机号码"
              v-model="current_person.phone"
            >
            </van-field>

            <!-- <van-field name="checkboxGroup" label="是否儿童"> </van-field> -->
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>是否儿童</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body">
                  <!-- <input type="text" name="radio" class="van-field__control" /> -->
                  <select
                    v-model="current_person.is_child"
                    style="padding: 0"
                    class="line-select"
                  >
                    <option value="1">是</option>
                    <option value="2">否</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- 是否签约人 -->
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>是否签约人</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body">
                  <select
                    v-model="current_person.isSigner"
                    style="padding: 0"
                    class="line-select"
                    :disabled="person_index === 0"
                  >
                    <option value="1">是</option>
                    <option value="0">否</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- <van-field
              name="checkboxGroup"
              label="地址"
              v-model="current_person.address"
              type="textarea"
              rows="2"
            >
            </van-field> -->
          </van-form>

          <div style="font-size: 12px;text-align: left;margin-top: 24px;">提示：①如团队签约，名单只需填写一个签约代表，剩余名单以表格形式上传至附件。②第一个用户必须是签约人。③出生日期，只有在委托购买-自动委托的且非身份证证件类型的情况下才需填写。</div>
        </div>
      </div>

      <div style="position: absolute; left: 0; right: 0; bottom: 0">
        <div class="cus-row">
          <div class="cus-row-col-6">
            <van-button
              type="danger"
              block
              style="background: #ffffff; color: #000000; border: none"
              @click="deletePerson"
              >删除</van-button
            >
          </div>
          <div class="cus-row-col-6">
            <van-button type="danger" block @click="choseTemplate"
              >继续
            </van-button>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 自愿购物编辑 -->
    <van-popup
      v-model="shopping_show"
      position="right"
      style="width: 82%; height: 100%; background: #f5f5f5; z-index: 99999"
    >
      <div style="box-shadow: 0px 2px 5px #eeeeee; background: #ffffff; margin-top: 2px;">
        <van-cell title="" is-link value="关闭" @click="shopping_show = false" />
      </div>
      <div style="overflow-y: scroll; height: calc(100% - 90px)">
        <div style="padding: 12px">
          <van-form>
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>日期</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body">
                  <input
                    class="van-field__control"
                    type="text"
                    readonly
                    :value="$refs.shopping_date_select ? $refs.shopping_date_select.dateStr : (current_shopping.date || '')"
                    @click="$refs.shopping_date_select.doSelect()"
                    placeholder="YYYY-MM-DD"
                  />
                </div>
              </div>
            </div>
            <van-field label="城市/地区" v-model="current_shopping.place" />
            <van-field label="购物场所" v-model="current_shopping.shoppingPlace" />
            <van-field label="主要商品" v-model="current_shopping.goods" />
            <van-field label="停留时长(分钟)" v-model="current_shopping.stayDuration" type="number" />
            <van-field label="备注" v-model="current_shopping.memo" type="textarea" rows="2" />
          </van-form>
        </div>
      </div>
      <div style="position: absolute; left: 0; right: 0; bottom: 0">
        <div class="cus-row">
          <div class="cus-row-col-6">
            <van-button type="danger" block style="background: #ffffff; color: #000000; border: none" @click="deleteShopping">删除</van-button>
          </div>
          <div class="cus-row-col-6">
            <van-button type="danger" block @click="shopping_show = false">完成</van-button>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- end of 游客编辑 -->

    <!--分享弹出层-->
    <van-popup
      v-model="more_show"
      round="true"
      position="bottom"
      :style="{ 'min-height': '10%' }"
    >
      <div>
        <div class="van-share-sheet__options">
          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="goView"
            v-if="info.status != 1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="newspaper-o" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">查看合同</span>
          </div>

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="refreshStatus"
            v-if="info.contract_state != 3 && info.status != 1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="replay" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">更新状态</span>
          </div>

          <!-- <div role="button" tabindex="0" class="van-share-sheet__option" @click="goSms">
                        <img src="https://img01.yzcdn.cn/vant/share-sheet-link.png" class="van-share-sheet__icon" /><span class="van-share-sheet__name">签署链接</span>
                    </div> -->

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="resend"
            v-if="[1, 2].indexOf(info.contract_state) != -1 && info.status != 1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="comment-o" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">签署短信</span>
          </div>

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="doCopy"
            v-if="[1, 2].indexOf(info.contract_state) != -1 && info.status != 1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="brush-o" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">复制链接</span>
          </div>

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="deleteJobDraft"
            v-if="info.status == 1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="delete" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">删除草稿</span>
          </div>

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="deleteContract"
            v-if="
              info.status != 1 && [1, 2, 3].indexOf(info.contract_state) != -1
            "
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="delete" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">作废合同</span>
          </div>

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="invalidateResend"
            v-if="info.status != 1 && [4].indexOf(info.contract_state) != -1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="comment-o" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">作废短信</span>
          </div>

          <!-- 保险操作按钮 -->
          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="updateInsuranceStatus"
            v-if="info.contract_insurance_batch_need_apply == 1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="replay" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">刷新保单</span>
          </div>

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="viewInsuranceList"
            v-if="showInsuranceMenu"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="description" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">保单列表</span>
          </div>
        </div>

        <button
          type="button"
          class="van-share-sheet__cancel"
          @click="doShareShowCancel"
        >
          取消
        </button>
      </div>
    </van-popup>

    <!-- 保单列表弹层 -->
    <van-popup
      v-model="insuranceModalVisible"
      round="true"
      position="bottom"
      :style="{ height: '85%' }"
      @open="refreshInsuranceOnModalOpen"
      @close="resetInsuranceModalState"
    >
      <div class="insurance-modal">
        <div class="insurance-modal-header">
          <div class="insurance-modal-title">保单列表</div>
          <div class="insurance-modal-toolbar">
            <van-button size="small" type="primary" plain @click="goExtraInsuranceApply">
              追加投保
            </van-button>
            <div class="insurance-cancel-switch">
              <span class="insurance-cancel-switch-label">开启退保</span>
              <van-switch v-model="insuranceCancelMode" size="20px" />
            </div>
          </div>
          <div v-if="insurancePlanCode" class="insurance-plan-hint">产品：{{ insurancePlanCode }}</div>
          <div v-if="insuranceCancelMode" class="insurance-cancel-tip">
            已开启退保，可按批次或单人操作撤保
          </div>
        </div>

        <div class="insurance-modal-body">
          <van-loading v-if="insuranceLoading" class="insurance-loading" />
          <template v-else>
            <div
              v-for="batch in insuranceBatches"
              :key="batch.external_order_no"
              class="insurance-batch-block"
            >
              <div class="insurance-batch-header">
                <div class="insurance-batch-title-row">
                  <span class="insurance-batch-label">{{ batch.label }}</span>
                  <van-button size="mini" plain :loading="insuranceLoading" @click="loadInsuranceBatches">
                    刷新
                  </van-button>
                  <van-button
                    v-if="insuranceCancelMode && batchHasCancellable(batch)"
                    size="mini"
                    type="danger"
                    plain
                    :loading="insuranceBatchCancelLoadingKey === batch.external_order_no"
                    :disabled="!!insuranceSingleCancelKey"
                    @click="cancelInsuranceBatch(batch)"
                  >
                    本批全部撤保
                  </van-button>
                </div>
                <div class="insurance-batch-order-no">{{ batch.external_order_no }}</div>
              </div>
              <div
                v-for="(item, index) in batch.items"
                :key="batch.external_order_no + '-' + index"
                class="insurance-card"
              >
                <div class="insurance-card-main">
                  <div class="insurance-left">
                    <div class="insurance-person-name">{{ item.name }}</div>
                    <div class="insurance-meta">
                      <span class="insurance-meta-item">{{ item.cardType }}</span>
                      <span class="insurance-meta-item">{{ item.cardNo }}</span>
                    </div>
                    <div class="insurance-policy-no">{{ item.externalPolicyNumber }}</div>
                  </div>
                  <div class="insurance-right">
                    <span :class="['insurance-status-tag', getStatusClass(item)]">
                      {{ getInsuranceStatusText(item) }}
                    </span>
                    <button
                      v-if="item.policyNo && item.service !== 'cancel'"
                      class="insurance-view-btn"
                      @click="viewPolicyDetail(item.policyNo)"
                    >
                      查看保单
                    </button>
                    <button
                      v-if="insuranceCancelMode && canCancelPolicy(item)"
                      class="insurance-cancel-btn"
                      :disabled="!!insuranceBatchCancelLoadingKey"
                      @click="cancelSingleInsurance(item, batch)"
                    >
                      <van-loading
                        v-if="insuranceSingleCancelKey === getPolicyCancelKey(batch, item)"
                        size="16px"
                      />
                      <span v-else>撤保</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="insuranceBatches.length === 0" class="insurance-empty">
              <van-icon name="description" class="insurance-empty-icon" />
              <div>暂无保单数据</div>
            </div>
          </template>
        </div>

        <div class="insurance-modal-footer">
          <van-button type="default" block class="insurance-close-btn" @click="closeInsuranceModal">
            关闭
          </van-button>
        </div>
      </div>
    </van-popup>

    <!-- 保险产品选择弹层（右侧弹出） -->
    <van-popup
      v-model="showProductPopup"
      position="right"
      :style="{ width: '88%', height: '100%' }"
    >
      <div class="product-popup">
        <div class="product-popup-header">
          <van-nav-bar
            title="选择保险产品"
            left-arrow
            @click-left="showProductPopup = false"
          />
        </div>
        <div class="product-popup-body">
          <van-loading v-if="loadingProducts" class="product-loading" />
          <template v-else>
            <div
              v-for="product in insuranceProducts"
              :key="product.plan_id"
              class="product-card"
              :class="{ 'selected': selectedPlanCode === product.plan_code, 'is-disabled': !insuranceDisclaimerAgreed }"
              @click="selectProduct(product)"
            >
              <div class="product-main-row">
                <div class="product-title-wrap">
                  <div class="product-name">{{ product.plan_name }}</div>
                  <div class="product-sub-row">
                    <span class="product-supplier">{{ product.supplier_name }}</span>
                    <span class="product-code">{{ product.plan_code }}</span>
                  </div>
                </div>
                <div class="product-action-wrap">
                  <span class="product-price">¥{{ product.min_price }}起</span>
                  <van-icon
                    v-if="selectedPlanCode === product.plan_code"
                    name="success"
                    class="selected-icon"
                    color="#07c160"
                  />
                  <span v-else class="select-text">选择</span>
                </div>
              </div>
              <div class="product-bottom-row">
                <div class="product-info">
                  <span v-if="extractCoverage(product.tag_names)" class="info-tag highlight">保额{{ extractCoverage(product.tag_names) }}</span>
                  <span class="info-tag">{{ product.min_age }}-{{ product.max_age }}岁</span>
                  <span class="info-tag">{{ product.min_day }}-{{ product.max_day }}天</span>
                </div>
                <span class="detail-link" @click.stop="openProductDetail(product.plan_id)">查看详情</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </van-popup>
  </div>
</template>


<script>
import common from "../assets/js/common";
import CusDatePicker from "../modules/cus_date_picker";
import { Dialog } from "vant";
import _ from "underscore";
import axios from "axios";
import { Toast } from "vant";
import serviceitem from "../components/serviceitem";
import FileSizeCheck from "../components/FileSizeCheck.vue";

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  components: {
    CusDatePicker,
    serviceitem,
    FileSizeCheck,
  },
  data: function () {
    return {
      template_type: "",
      begin_time: "",
      price: "",
      pay_username: "",
      collection_username: "",
      pay_date: "",
      faceImg: "",
      tabIndex: 1,
      list: [],
      list_combine: [],
      more_show: false,
      taxlist: [],
      currentId: "",
      invoFlag: false,
      taxpayer_number: "",
      title: "",
      email: "",
      invoiceType: -1,
      chosenFlag: false,
      fillFlag: false,
      page_list: true,
      checked: false,
      detailFlag: false,
      detailItem: {},
      taxpayer_phone: "",
      taxpayer_bank: "",
      bank_account: "",
      showPicSrc: "",
      shouquanshu: "",
      taxpayer_address: "",
      contract_no: "",
      bank_name: "",
      remark: "",
      nextLock: "",
      show: false,
      person_show: false,

      // 保单相关
      insuranceModalVisible: false,
      insuranceLoading: false,
      insuranceBatches: [],
      insurancePlanCode: '',
      insuranceCancelMode: false,
      insuranceBatchCancelLoadingKey: null,
      insuranceSingleCancelKey: null,

      id: this.$route.query.id,
      info: {},

      contract_type: "",
      contract_begin_day: "",
      contract_end_day: "",
      contract_begin_time: "",
      contract_end_time: "",
      contract_pay_day: "",
      contract_name: "",

      contract_adult_price: "",
      contract_child_price: "",
      contract_adult_count: "",
      contract_child_count: "",
      contract_price: "",
      contract_pay_remark: "",
      contract_payway: "",

      contract_insurance_method: "",
      contract_entrust_type: "", // 1手动委托 2自动委托
      contract_insurance_productname: "",
      contract_insurance_plan_code: "", // 自动委托选中的产品代码
      insuranceProducts: [], // 保险产品列表
      showProductPopup: false, // 产品选择弹层
      selectedPlanCode: "", // 选中的产品代码
      selectedProductObj: null, // 选中的产品对象
      loadingProducts: false, // 产品加载状态
      insuranceDisclaimerAgreed: false,
      insuranceDisclaimerText:
        '免责声明：自动投保仅为系统辅助功能，不保证投保成功、不保证与保险公司最终承保结果一致。保障内容、生效时间及法律效力均以保险公司实际出具并生成的保单为准；系统内状态、提示仅供参考。选择自动委托前，请确认理解：须自行在合同签订后核对是否已取得有效保单；未核实保单即视为业务已办结的，相关风险及责任由业务方自行承担，与系统开发及平台运营方无关。本人已阅读并同意上述说明。',

      contract_group_min_count: "",
      contract_group_way: "",
      contract_group_othername: "",
      contract_group_agree: "",
      contract_dispute_tribunalname: "",
      contract_dispute_way: "",

      contract_days: "",
      contract_nights: "",

      course_data: [],
      person_index: -1,
      current_person: {},
      fileList: [],
      isTestMode: common.isTestMode(),
      shoppings: [],
      shopping_show: false,
      shopping_index: -1,
      current_shopping: {},

      local_travel_agency: {
        agency_name: "",
        agency_address_description: "",
        contact_name: "",
        contact_phone: "",
      },
    };
  },
  methods: {
    deleteContract() {
      Dialog.confirm({
        title: "操作提醒",
        message: "确认要作废当前合同吗?",
      }).then(() => {
        // this.person_show = false;
        // _.remove(this.course_data,);
        // this.fileList.splice(index, 1);
        // this.person_index = -1;
        // common.mAlert(this, "重发短信成功");

        common
          .cusHttp(
            this,
            "/admin_user.php?action=cancel_contract",
            { id: this.id },
            "get"
          )
          .then((res) => {
            console.log("作废成功");
            common.mAlert(this, "作废成功");
            // this.goBack()
            this.initPage();
          });
      });
    },

    deleteJobDraft() {
      Dialog.confirm({
        title: "操作提醒",
        message: "确认要删除当前草稿吗?",
      }).then(() => {
        // this.person_show = false;
        // _.remove(this.course_data,);
        // this.fileList.splice(index, 1);
        // this.person_index = -1;
        // common.mAlert(this, "重发短信成功");

        common
          .cusHttp(
            this,
            "/admin_user.php?action=deleted_job",
            { id: this.id },
            "get"
          )
          .then((res) => {
            console.log("删除成功");
            common.mAlert(this, "删除成功");
            this.goBack();
          });
      });
    },

    goBack() {
      this.$router.push({ path: "/" });
    },
    invalidateResend() {
      console.log("重发短信");
      Dialog.confirm({
        title: "操作提醒",
        message: "是否要重发签署短信，点击确认将自动发送？",
      }).then(() => {
        // this.person_show = false;
        // _.remove(this.course_data,);
        // this.fileList.splice(index, 1);
        // this.person_index = -1;
        common.mAlert(this, "重发短信成功");

        common.cusHttp(
          this,
          "/admin_user.php?action=contract_invalid_resend",
          { id: this.id },
          "get"
        );
      });
    },
    resend() {
      // contractResend({id: record.id}).then((res)=>{
      //   this.$message.success('重发短信成功')
      // })
      console.log("重发短信");
      Dialog.confirm({
        title: "操作提醒",
        message: "是否要重发签署短信？",
      }).then(() => {
        // this.person_show = false;
        // _.remove(this.course_data,);
        // this.fileList.splice(index, 1);
        // this.person_index = -1;
        common.mAlert(this, "重发短信成功");

        common.cusHttp(
          this,
          "/admin_user.php?action=contract_resend",
          { id: this.id },
          "get"
        );
      });
    },

    refreshStatus() {
      // console.log("刷新状态", record)
      // syncContractStatus({id: record.id}).then((res)=>{
      //   this.$message.success('状态更新成功')
      //   this.$refs.table.refresh()
      // })

      Dialog.confirm({
        title: "操作提醒",
        message: "是否要手动更新状态？",
      }).then(() => {
        // common.mAlert(this, "重发短信成功");
        common
          .cusHttp(
            this,
            "/admin_user.php?action=sync_contract_status",
            { id: this.id },
            "get"
          )
          .then((res) => {
            common.mAlert(this, "更新状态成功");
            this.initPage();
          });
      });
    },

    doCopy() {
      common.mAlert(this, "复制成功");
      common.copy(this.info.contract_sign_url);
    },

    goView() {
      console.log("查看合同内容");
      window.open(this.info.contract_file_url, "_target");
    },

    showMore() {
      this.more_show = true;
    },
    doShareShowCancel() {
      this.more_show = false;
    },

    // 刷新保单状态（主合同同步）
    updateInsuranceStatus() {
      this.more_show = false;
      Dialog.confirm({
        title: "操作提醒",
        message: "是否要刷新保单状态？",
      }).then(() => {
        common
          .cusHttp(
            this,
            "/admin_jobs.php?action=sync_contract_insurece_status",
            { id: this.id },
            "get"
          )
          .then((res) => {
            const apiRes = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
            if (apiRes.errcode === 0) {
              common.mAlert(this, "保单状态更新成功");
              this.initPage();
              if (this.insuranceModalVisible) {
                this.loadInsuranceBatches();
              }
            } else {
              common.mAlert(this, apiRes.errmsg || "保单状态更新失败");
            }
          })
          .catch(() => {
            common.mAlert(this, "请求失败，请稍后重试");
          });
      });
    },

    viewInsuranceList() {
      this.openInsuranceModal();
    },

    openInsuranceModal() {
      this.more_show = false;
      this.insuranceCancelMode = false;
      this.insuranceModalVisible = true;
    },

    refreshInsuranceOnModalOpen() {
      this.loadInsuranceBatches(true);
    },

    goExtraInsuranceApply() {
      this.insuranceModalVisible = false;
      this.$router.push({
        path: "/extra_insurance_apply",
        query: { id: this.id },
      });
    },

    loadInsuranceBatches(refreshRemote = true) {
      this.insuranceLoading = true;
      common
        .cusHttp(
          this,
          "/admin_contract_insurance.php?action=list_contract_insurance_batches",
          { id: this.id, refresh: refreshRemote ? "1" : "0" },
          "get"
        )
        .then((res) => {
          const apiRes = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
          if (apiRes.errcode === 0 && apiRes.data) {
            this.insuranceBatches = apiRes.data.batches || [];
            this.insurancePlanCode = apiRes.data.plan_code || "";
          } else {
            common.mAlert(this, apiRes.errmsg || "获取保单数据失败");
          }
        })
        .catch(() => {
          common.mAlert(this, "请求失败，请稍后重试");
        })
        .finally(() => {
          this.insuranceLoading = false;
        });
    },

    closeInsuranceModal() {
      this.insuranceModalVisible = false;
      this.resetInsuranceModalState();
    },

    resetInsuranceModalState() {
      this.insuranceCancelMode = false;
      this.insuranceBatchCancelLoadingKey = null;
      this.insuranceSingleCancelKey = null;
      this.insuranceBatches = [];
      this.insurancePlanCode = "";
    },

    batchHasCancellable(batch) {
      return (batch.items || []).some((item) => this.canCancelPolicy(item));
    },

    canCancelPolicy(item) {
      return item.service === "apply" && item.status === "SUCCESS" && !!item.policyNo;
    },

    getPolicyCancelKey(batch, item) {
      return `${batch.external_order_no}:${item.externalPolicyNumber}`;
    },

    submitInsuranceCancel(batch, externalPolicyNumber) {
      const isSingle = !!externalPolicyNumber;
      if (isSingle) {
        this.insuranceSingleCancelKey = this.getPolicyCancelKey(
          batch,
          { externalPolicyNumber }
        );
      } else {
        this.insuranceBatchCancelLoadingKey = batch.external_order_no;
      }

      const clearLoading = () => {
        this.insuranceBatchCancelLoadingKey = null;
        this.insuranceSingleCancelKey = null;
      };

      if (batch.type === "contract" && !isSingle) {
        return common
          .cusHttp(
            this,
            "/admin_jobs.php?action=cancel_contract_insurance",
            { id: this.id },
            "get"
          )
          .finally(clearLoading);
      }

      const params = {
        id: this.id,
        external_order_no: batch.external_order_no,
      };
      if (externalPolicyNumber) {
        params.external_policy_number = externalPolicyNumber;
      }
      return common
        .cusHttp(
          this,
          "/admin_contract_insurance.php?action=cancel_contract_insurance_batch",
          params,
          "get"
        )
        .finally(clearLoading);
    },

    cancelSingleInsurance(item, batch) {
      Dialog.confirm({
        title: "确认撤保",
        message: `确定对 ${item.name} 的保单发起撤保吗？撤保后该保单将无法继续生效。`,
      }).then(() => {
        this.submitInsuranceCancel(batch, item.externalPolicyNumber)
          .then((res) => {
            const apiRes = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
            if (apiRes.errcode === 0) {
              common.mAlert(this, "撤保申请已提交");
              this.initPage();
              this.loadInsuranceBatches();
            } else {
              common.mAlert(this, apiRes.errmsg || "撤保失败");
            }
          })
          .catch(() => {
            common.mAlert(this, "撤保请求失败，请稍后重试");
          });
      });
    },

    cancelInsuranceBatch(batch) {
      Dialog.confirm({
        title: "确认本批全部撤保",
        message: `确定对「${batch.label}」(${batch.external_order_no}) 全部撤保吗？`,
      }).then(() => {
        this.submitInsuranceCancel(batch)
          .then((res) => {
            const apiRes = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
            if (apiRes.errcode === 0) {
              common.mAlert(this, "撤保申请已提交");
              this.initPage();
              this.loadInsuranceBatches();
            } else {
              common.mAlert(this, apiRes.errmsg || "撤保失败");
            }
          })
          .catch(() => {
            common.mAlert(this, "撤保请求失败，请稍后重试");
          });
      });
    },

    viewPolicyDetail(policyNo) {
      if (!policyNo) return;
      window.open(
        `https://apicontract.yishouyou.com.cn/boot_new/boot/gold_palm_task.php?action=download&policyNo=${policyNo}`,
        "_blank"
      );
    },

    // 获取保单状态CSS类名
    getStatusClass(item) {
      // 撤保时 service 为 cancel
      if (item.service === 'cancel') {
        return 'status-cancelled'
      }
      return 'status-' + (item.status ? item.status.toLowerCase() : 'default')
    },

    // 获取保单状态文本
    getInsuranceStatusText(item) {
      // 撤保时 service 为 cancel，status 仍为 SUCCESS
      if (item.service === 'cancel') {
        return '已取消'
      }
      const textMap = {
        SUCCESS: '成功',
        PROCESSING: '处理中',
        FAILED: '失败',
      }
      return textMap[item.status] || item.status
    },

    // 保险方式变化处理
    onInsuranceMethodChange() {
      // 清空相关字段
      this.contract_entrust_type = "";
      this.contract_insurance_productname = "";
      this.resetInsuranceDisclaimer();
      this.clearAutoInsuranceProduct();
    },

    // 委托方式变化处理
    onEntrustTypeChange() {
      this.resetInsuranceDisclaimer();
      // 清空产品相关字段
      if (this.contract_entrust_type === "1") {
        // 切换到手动委托：清空自动委托相关字段，同时清空产品名称（避免显示自动委托的产品）
        this.clearAutoInsuranceProduct();
        this.contract_insurance_productname = "";
      } else {
        // 切换到自动委托：清空手动输入的产品名称
        this.contract_insurance_productname = "";
      }
    },

    resetInsuranceDisclaimer() {
      this.insuranceDisclaimerAgreed = false;
      this.showProductPopup = false;
    },

    clearAutoInsuranceProduct() {
      this.selectedPlanCode = "";
      this.contract_insurance_plan_code = "";
      this.selectedProductObj = null;
    },

    onInsuranceDisclaimerChange() {
      if (!this.insuranceDisclaimerAgreed) {
        this.clearAutoInsuranceProduct();
      }
    },

    validateAutoInsuranceForSubmit() {
      if (this.contract_insurance_method != "1" || this.contract_entrust_type != "2") {
        return true;
      }
      if (!this.insuranceDisclaimerAgreed) {
        common.mAlert(this, "请先阅读并勾选同意免责声明");
        return false;
      }
      const planCode = this.selectedPlanCode || this.contract_insurance_plan_code;
      if (!planCode) {
        common.mAlert(this, "请选择保险产品");
        return false;
      }
      return true;
    },

    // 打开产品选择弹层
    openProductPopup() {
      if (!this.insuranceDisclaimerAgreed) {
        common.mAlert(this, "请先阅读并勾选同意免责声明");
        return;
      }
      this.showProductPopup = true;
      this.fetchInsuranceProducts();
    },

    // 获取保险产品列表
    fetchInsuranceProducts() {
      this.loadingProducts = true;
      // 根据合同类型判断是境内游还是出境游
      // A00001/C00001 是境内游，使用 domestic; 其他如 E00001(机票)等使用 overseas
      const type = (this.contract_type === 'A00001' || this.contract_type === 'C00001') ? 'domestic' : 'overseas';
      common
        .cusHttp(this, `/get_insurance_products.php?type=${type}`, {}, "get")
        .then((res) => {
          const apiRes = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
          if (apiRes.ok && apiRes.data) {
            this.insuranceProducts = apiRes.data;
            // 如果有已选中的产品代码，自动匹配产品对象
            if (this.selectedPlanCode) {
              const matched = this.insuranceProducts.find(p => p.plan_code === this.selectedPlanCode);
              if (matched) {
                this.selectedProductObj = matched;
              }
            }
          } else {
            common.mAlert(this, apiRes.msg || "加载保险产品失败");
          }
        })
        .catch((err) => {
          common.mAlert(this, "加载保险产品失败");
        })
        .finally(() => {
          this.loadingProducts = false;
        });
    },

    // 选择产品（自动委托模式）
    selectProduct(product) {
      if (!this.insuranceDisclaimerAgreed) {
        common.mAlert(this, "请先阅读并勾选同意免责声明");
        return;
      }
      console.log("[选择产品] product:", product);
      this.selectedPlanCode = product.plan_code;
      this.contract_insurance_plan_code = product.plan_code;
      // 自动委托不使用 contract_insurance_productname，只保存产品对象用于显示
      this.selectedProductObj = product;
      console.log("[选择产品] selectedPlanCode:", this.selectedPlanCode);
      console.log("[选择产品] selectedProductObj:", this.selectedProductObj);
      this.showProductPopup = false;
    },

    // 解析标签
    parseTags(tagNames) {
      if (!tagNames) return [];
      return tagNames.split(",").map((t) => t.trim()).filter((t) => t);
    },

    // 从 tag_names 中提取保额
    extractCoverage(tagNames) {
      if (!tagNames) return null;
      const tags = tagNames.split(",");
      for (const tag of tags) {
        const match = tag.match(/保额\s*(\d+\s*万?)/);
        if (match) {
          return match[1].includes("万") ? match[1] : match[1] + "万";
        }
      }
      return null;
    },

    // 打开产品详情页
    openProductDetail(planId) {
      const detailUrl = `https://apicontract.yishouyou.com.cn/boot_new/boot/gold_palm_product_detail.php?id=${planId}`;
      window.open(detailUrl, '_blank');
    },

    deleteFile(item, index) {
      Dialog.confirm({
        title: "操作提醒",
        message: "是否要删除当前文件？",
      }).then(() => {
        // this.person_show = false;
        // _.remove(this.course_data,);
        this.fileList.splice(index, 1);
        // this.person_index = -1;
      });
    },
    isPdfUrl(url) {
      // 使用正则表达式判断地址是否以.pdf结尾
      const pdfPattern = /\.pdf$/i;
      return pdfPattern.test(url);
    },
    getFileNameFromUrl(url) {
      // 使用 URL 构造函数解析给定的 URL
      const parsedUrl = new URL(url);

      // 从路径中获取最后的部分，即文件名
      const pathname = parsedUrl.pathname;
      const fileName = pathname.substring(pathname.lastIndexOf("/") + 1);

      return fileName;
    },
    getFile() {
      const inputFile = this.$refs.upload.files[0];
      if (inputFile) {
        if (
          inputFile.type !==
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&
          inputFile.type !== "application/pdf"
        ) {
          alert("不是有效的docx,pdf文件！");
          return;
        }

        // var formElement = document.querySelector("#data-form");
        var formData = new FormData();
        formData.append("file", inputFile);

        axios
          .post(common.dynamicHost() + "/upload.php", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.$refs.upload.value = "";
            console.log("正常上传");
            console.log(res);
            res = res.data;
            if (res.errcode == 0) {
              this.fileList.push(common.dynamicHost() + res.path);
              return;
            }
            alert("异常上传");
          })
          .catch((err) => {
            this.$refs.upload.value = "";
            console.log("异常上传");
            alert("异常上传");
          });

        // uploadCertificate(formData).then((res) => {
        //   this.$refs.filElem.value = "";
        //   if (res.status === 1) {
        //     this.logo_path = res.img;
        //   } else {
        //     this.$notification["error"]({
        //       message: "错误",
        //       description: res.errmsg,
        //       duration: 4,
        //     });
        //   }
        // });

        //TODO 公共的图片上传
        // this.$common.serverIp() + '/upload.php'
      } else {
        return;
      }
    },

    beforeRead() {
      return true;
    },
    addPerson: {},

    deletePerson() {
      Dialog.confirm({
        title: "操作提醒",
        message: "是否要删除当前游客？",
      }).then(() => {
        this.person_show = false;
        // _.remove(this.course_data,);
        this.course_data.splice(this.person_index, 1);
        this.person_index = -1;
        // 保证第一位始终为签约人
        if (this.course_data.length > 0) {
          if (typeof this.course_data[0].isSigner === 'undefined') {
            this.$set(this.course_data[0], 'isSigner', '1');
          } else {
            this.course_data[0].isSigner = '1';
          }
        }
      });
    },

    editPerson(item, index) {
      this.person_index = index;
      this.current_person = this.course_data[this.person_index];
      // 约束：第一位游客必须为签约人，其余默认非签约人
      if (this.person_index === 0) {
        this.$set(this.current_person, "isSigner", "1");
      } else if (typeof this.current_person.isSigner === "undefined") {
        this.$set(this.current_person, "isSigner", "0");
      }
      this.person_show = true;
    },

    cardtypeTxt(type) {
      // <option value="1">身份证</option>
      //             <option value="4">护照</option>
      //             <option value="6">回乡证</option>
      if (type == 1) {
        return "身份证";
      }

      if (type == 4) {
        return "护照";
      }

      if (type == 6) {
        return "回乡证";
      }

      if (type == 8) {
        return "其他";
      }
      return;
    },

    // 格式化出生日期输入：将 20001103 转换为 2000-11-03
    formatBirthdayInput() {
      let value = this.current_person.birthday;
      if (!value) return;

      // 去除空格
      value = value.trim();

      // 如果已经是带横杠的格式，验证有效性
      if (value.includes('-')) {
        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
          this.current_person.birthday = value;
        }
        return;
      }

      // 纯数字格式 20001103 -> 2000-11-03
      if (/^\d{8}$/.test(value)) {
        const year = value.substring(0, 4);
        const month = value.substring(4, 6);
        const day = value.substring(6, 8);

        // 验证日期有效性
        const date = new Date(year + '-' + month + '-' + day);
        if (date.getFullYear() === parseInt(year) &&
            date.getMonth() + 1 === parseInt(month) &&
            date.getDate() === parseInt(day)) {
          this.current_person.birthday = year + '-' + month + '-' + day;
        }
      }
    },

    // 统一处理 course_data 中的日期格式（提交前调用）
    processBirthdayFormat(data) {
      return data.map(person => {
        const cloned = { ...person };
        if (cloned.birthday) {
          // 如果是 20001103 格式，转换为 2000-11-03
          const value = cloned.birthday.toString().trim();
          if (/^\d{8}$/.test(value)) {
            const year = value.substring(0, 4);
            const month = value.substring(4, 6);
            const day = value.substring(6, 8);
            cloned.birthday = year + '-' + month + '-' + day;
          }
        }
        return cloned;
      });
    },

    addCourse() {
      const willBeFirst = this.course_data.length === 0;
      this.course_data.push({
        // id: this.course_data.length + 1,
        name: "",
        area: "",
        address: "",
        industry_name: "",
        branch_scheme: "",
        size: "",
        editable: true,
        isSigner: willBeFirst ? "1" : "0",
        gender: "",
      });

      this.person_index = this.course_data.length - 1;
      this.current_person = this.course_data[this.person_index];
      this.person_show = true;
    },

    // 自愿购物
    addShopping() {
      this.shoppings.push({ date: '', place: '', shoppingPlace: '', goods: '', stayDuration: '', memo: '' });
      this.shopping_index = this.shoppings.length - 1;
      this.current_shopping = this.shoppings[this.shopping_index];
      this.shopping_show = true;
    },
    editShopping(item, index) {
      this.shopping_index = index;
      this.current_shopping = this.shoppings[this.shopping_index];
      this.shopping_show = true;
    },
    deleteShopping() {
      if (typeof this.shopping_index === 'number' && this.shopping_index > -1) {
        this.shoppings.splice(this.shopping_index, 1);
      }
      this.shopping_index = -1;
      this.shopping_show = false;
    },

    choseTemplate() {
      this.person_show = false;
    },

    saveDraft() {
      //TODO 暂存草稿操作
      Dialog.confirm({
        title: "操作提醒",
        message: "是否将资料暂存草稿？",
      })
        .then(() => {
          // on confirm
          //TODO:清空
          // this.pay_username = '';
          // this.collection_username = '';
          // this.price = '';
          // this.pay_date = moment().format('YYYY-MM-DD')
          // this.attachment = '';

          //处理游客信息
          let _self = this;

          //还是要判断格式，就算存草稿也要正确格式的
          //遍历校验数据是否填写完全
          for (let i = 0, j = _self.course_data.length; i < j; i++) {
            if (!_self.course_data[i].name) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客姓名不能为空`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客姓名不能为空`);
              return false;
            }

            if (!_self.course_data[i].cardtype) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客证件类型不能为空`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客证件类型不能为空`);
              return false;
            }

            if (!_self.course_data[i].idcard) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客证件号不能为空`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客证件号不能为空`);
              return false;
            }

            //TDOO
            if (
              _self.course_data[i].cardtype == 1 &&
              !/(^\d{15}$)|(^\d{17}(x|X|\d)$)/.test(_self.course_data[i].idcard)
            ) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客身份证号格式异常`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客身份证号格式异常`);
              return false;
            }

            if (!_self.course_data[i].phone) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客手机号不能为空`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客手机号不能为空`);
              return false;
            }

            // /^1\d{10}$/

            if (!/^1\d{10}$/.test(_self.course_data[i].phone)) {
              //   _self.$notification['error']({
              //     message: '错误',
              //     description: '手机号格式异常',
              //     duration: 4,
              //   })
              common.mAlert(this, `第${i + 1}个游客手机号格式异常`);
              return;
            }

            if (!_self.course_data[i].is_child) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: "是否儿童不能为空",
              //     duration: 4,
              //   });
              common.mAlert(this, `是否儿童不能为空`);
              return false;
            }

            // if (i == 0) {
            //   if (!_self.course_data[i].address) {
            //     // _self.$notification["error"]({
            //     //   message: "错误",
            //     //   description: `游客代表地址不能为空`,
            //     //   duration: 4,
            //     // });
            //     common.mAlert(this, `游客代表地址不能为空`);

            //     return false;
            //   }
            // }
          }

          console.log("游客信息输出");
          console.log(_self.course_data);
          //   return {
          //     contract_person_json: JSON.stringify(_self.course_data),
          //     contract_person_count: _self.course_data.length,
          //     contract_main_phone: _self.course_data.length
          //       ? _self.course_data[0].phone
          //       : "",
          //     contract_main_name: _self.course_data.length
          //       ? _self.course_data[0].name
          //       : "",
          //   };

          // 补齐签约人字段：第一个固定为 '1'，其他默认 '0'
          _self.course_data = _self.course_data.map(function(p, idx){
            var cloned = Object.assign({}, p);
            if (idx === 0) {
              cloned.isSigner = '1';
            } else if (typeof cloned.isSigner === 'undefined') {
              cloned.isSigner = '0';
            }
            return cloned;
          });

          // 处理出生日期格式：将 20001103 转换为 2000-11-03
          _self.course_data = this.processBirthdayFormat(_self.course_data);

          // let contract_plane =
          //   this.contract_type != "E00001" ? "" : this.$refs.plane.getData();
          // let contract_hotel =
          //   this.contract_type != "E00001" ? "" : this.$refs.hotel.getData();
          // let contract_car =
          //   this.contract_type != "E00001" ? "" : this.$refs.car.getData();
          // let contract_dao =
          //   this.contract_type != "E00001" ? "" : this.$refs.dao.getData();
          // let contract_visa =
          //   this.contract_type != "E00001" ? "" : this.$refs.visa.getData();

          common
            .cusHttp(
              this,
              "/admin_user.php?action=add_or_modify_job",
              {
                id: this.id,
                contract_begin_day: this.contract_begin_day,
                contract_end_day: this.contract_end_day,
                contract_begin_time: this.contract_begin_time,
                contract_end_time: this.contract_end_time,
                contract_pay_day: this.contract_pay_day,
                contract_name: this.contract_name,

                contract_adult_price: this.contract_adult_price,
                contract_child_price: this.contract_child_price,
                contract_adult_count: this.contract_adult_count,
                contract_child_count: this.contract_child_count,
                contract_price: this.contract_price,
                contract_pay_remark: this.contract_pay_remark,
                contract_payway: this.contract_payway,
                contract_service_price: this.contract_service_price,
                contract_single_price: this.contract_single_price,

                contract_insurance_method: this.contract_insurance_method,
                contract_entrust_type: this.contract_entrust_type,
                contract_insurance_productname:
                  this.contract_insurance_productname,
                contract_insurance_plan_code: this.contract_insurance_plan_code,
                contract_group_min_count: this.contract_group_min_count,
                contract_group_way: this.contract_group_way,
                contract_group_othername: this.contract_group_othername,
                contract_group_agree: this.contract_group_agree,
                contract_dispute_tribunalname:
                  this.contract_dispute_tribunalname,
                contract_dispute_way: 2,
                contract_days: this.contract_days,
                contract_nights: this.contract_nights,

                contract_person_json: JSON.stringify(_self.course_data),
                contract_person_count: _self.course_data.length,
                contract_main_phone: _self.course_data.length
                  ? _self.course_data[0].phone
                  : "",
                contract_main_name: _self.course_data.length
                  ? _self.course_data[0].name
                  : "",

                contract_attachment: JSON.stringify(_self.fileList),
                shoppings: JSON.stringify(this.shoppings),
                contract_plane:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.plane.getData(),
                contract_hotel:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.hotel.getData(),
                contract_car:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.car.getData(),
                contract_dao:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.dao.getData(),
                contract_visa:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.visa.getData(),
                contract_other:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.other.getData(),
                contract_rule:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.rule.getData(),

                local_travel_agency: JSON.stringify(this.local_travel_agency),
              },
              "post"
            )
            .then((res) => {
              common.mAlert(this, "暂存草稿成功");
              //   console.log("job_detail返回", res);
              //   res = JSON.parse(res.data);
              //   if (res.errcode == 0) {
              //     // this.static = res.data
              //     // console.log(JSON.stringify(res.data.loan_list));
              //     // this.list = res.data.loan_list;
              //     //   this.pending_list = res.result.data
              //     //   this.currentListLoading = false
              //     let info = res.data;
              //     this.info = info;

              //     this.contract_type = info.contract_type;
              //     console.log("输出Info");
              //     console.log(this.info);
              //   }
            });
        })
        .catch(() => {
          // on cancel
          //返回上一页
          //   this.$router.push("/invoice");
        });
    },



    doPreview() {
      // 预览操作
      let _self = this;

      /** start of  产品信息和费用 **/
      if (!_self.contract_name) {
        common.mAlert(this, `线路名称不能为空`);
        return false;
      }

      if (!_self.course_data.length) {
        common.mAlert(this, `至少需要一位游客`);
        return false;
      }

      // 游客信息校验
      for (let i = 0, j = _self.course_data.length; i < j; i++) {
        if (!_self.course_data[i].name) {
          common.mAlert(this, `第${i + 1}个游客姓名不能为空`);
          return false;
        }
        if (!_self.course_data[i].cardtype) {
          common.mAlert(this, `第${i + 1}个游客证件类型不能为空`);
          return false;
        }
        if (!_self.course_data[i].idcard) {
          common.mAlert(this, `第${i + 1}个游客证件号不能为空`);
          return false;
        }
        if (
          _self.course_data[i].cardtype == 1 &&
          !/(^\d{15}$)|(^\d{17}(x|X|\d)$)/.test(_self.course_data[i].idcard)
        ) {
          common.mAlert(this, `第${i + 1}个游客身份证号格式异常`);
          return false;
        }
        if (!_self.course_data[i].phone) {
          common.mAlert(this, `第${i + 1}个游客手机号不能为空`);
          return false;
        }
        if (!/^1\d{10}$/.test(_self.course_data[i].phone)) {
          common.mAlert(this, `第${i + 1}个游客手机号格式异常`);
          return;
        }
        if (!_self.course_data[i].is_child) {
          common.mAlert(this, `是否儿童不能为空`);
          return false;
        }
      }

      if (this.contract_type == "E00001") {
      } else {
        if (!_self.contract_begin_day) {
          common.mAlert(this, `出发日期不能为空`);
          return false;
        }
        if (!_self.contract_end_day) {
          common.mAlert(this, `结束日期不能为空`);
          return false;
        }
        if (!_self.contract_days) {
          common.mAlert(this, `天数不能为空`);
          return false;
        }
        if (_self.contract_nights === "") {
          common.mAlert(this, `夜晚数不能为空`);
          return false;
        }
        if (!_self.contract_adult_price) {
          common.mAlert(this, `成人价不能为空`);
          return false;
        }
        if (!_self.contract_child_price) {
          common.mAlert(this, `儿童价不能为空`);
          return false;
        }
        if (!_self.contract_service_price) {
          common.mAlert(this, `导游服务费不能为空`);
          return false;
        }
        if (!_self.contract_single_price) {
          common.mAlert(this, `单房差不能为空`);
          return false;
        }
        if (_self.contract_adult_count === "") {
          common.mAlert(this, `成人人数不能为空`);
          return false;
        }
        if (_self.contract_child_count === "") {
          common.mAlert(this, `儿童人数不能为空`);
          return false;
        }
        if (!_self.contract_price) {
          common.mAlert(this, `旅游费用不能为空`);
          return false;
        }
        if (!_self.contract_payway) {
          common.mAlert(this, `支付方式不能为空`);
          return false;
        }
        if (!_self.contract_pay_day) {
          common.mAlert(this, `支付时间不能为空`);
          return false;
        }

        /** end of 产品信息和费用 **/

        if (!_self.contract_insurance_method) {
          common.mAlert(this, `意外伤害保险不能为空`);
          return false;
        }
        if (!_self.validateAutoInsuranceForSubmit()) {
          return false;
        }
        if (_self.contract_group_min_count === "") {
          common.mAlert(this, `最低成团人数不能为空`);
          return false;
        }
        if (!_self.contract_group_way) {
          common.mAlert(this, `不成团约定不能为空`);
          return false;
        }
        if (!_self.contract_group_agree) {
          common.mAlert(this, `拼团约定不能为空`);
          return false;
        }
        if (!_self.fileList.length) {
          common.mAlert(this, `附件不能为空`);
          return false;
        }
      }

      // 补齐签约人字段
      _self.course_data = _self.course_data.map(function(p, idx){
        var cloned = Object.assign({}, p);
        if (idx === 0) {
          cloned.isSigner = '1';
        } else if (typeof cloned.isSigner === 'undefined') {
          cloned.isSigner = '0';
        }
        return cloned;
      });

      // 处理出生日期格式：将 20001103 转换为 2000-11-03
      _self.course_data = this.processBirthdayFormat(_self.course_data);

      Toast.loading({
        duration: 0,
        mask: true,
        message: "正在生成预览...",
      });

      // 1. 先保存 (使用 add_or_modify_job)
      common
        .cusHttp(
          this,
          "/admin_user.php?action=add_or_modify_job",
          {
            id: this.id,
            contract_begin_day: this.contract_begin_day,
            contract_end_day: this.contract_end_day,
            contract_begin_time: this.contract_begin_time,
            contract_end_time: this.contract_end_time,
            contract_pay_day: this.contract_pay_day,
            contract_name: this.contract_name,

            contract_adult_price: this.contract_adult_price,
            contract_child_price: this.contract_child_price,
            contract_adult_count: this.contract_adult_count,
            contract_child_count: this.contract_child_count,
            contract_price: this.contract_price,
            contract_pay_remark: this.contract_pay_remark,
            contract_payway: this.contract_payway,
            contract_service_price: this.contract_service_price,
            contract_single_price: this.contract_single_price,
            contract_days: this.contract_days,
            contract_nights: this.contract_nights,

            contract_insurance_method: this.contract_insurance_method,
            contract_entrust_type: this.contract_entrust_type,
            contract_insurance_productname: this.contract_insurance_productname,
            contract_insurance_plan_code: this.contract_insurance_plan_code,
            contract_group_min_count: this.contract_group_min_count,
            contract_group_way: this.contract_group_way,
            contract_group_othername: this.contract_group_othername,
            contract_group_agree: this.contract_group_agree,
            contract_dispute_tribunalname: this.contract_dispute_tribunalname,
            contract_dispute_way: 2,

            contract_person_json: JSON.stringify(_self.course_data),
            contract_person_count: _self.course_data.length,
            contract_main_phone: _self.course_data.length
              ? _self.course_data[0].phone
              : "",
            contract_main_name: _self.course_data.length
              ? _self.course_data[0].name
              : "",

            contract_attachment: JSON.stringify(_self.fileList),
            shoppings: JSON.stringify(this.shoppings),
            contract_plane:
              this.contract_type != "E00001"
                ? ""
                : this.$refs.plane.getData(),
            contract_hotel:
              this.contract_type != "E00001"
                ? ""
                : this.$refs.hotel.getData(),
            contract_car:
              this.contract_type != "E00001"
                ? ""
                : this.$refs.car.getData(),
            contract_dao:
              this.contract_type != "E00001"
                ? ""
                : this.$refs.dao.getData(),
            contract_visa:
              this.contract_type != "E00001"
                ? ""
                : this.$refs.visa.getData(),
            contract_other:
              this.contract_type != "E00001"
                ? ""
                : this.$refs.other.getData(),
            contract_rule:
              this.contract_type != "E00001"
                ? ""
                : this.$refs.rule.getData(),

            local_travel_agency: JSON.stringify(this.local_travel_agency),
          },
          "post"
        )
        .then((res) => {
          // 保存成功，请求预览
          res = JSON.parse(res.data);
           if (res.errcode == 0) {
              var previewUrl = "/admin_contract_preview.php";
              if (_self.contract_type === "E00001") {
                  previewUrl = "/admin_user.php?action=preview_contract";
              } else if (_self.contract_type === "A00001") {
                  previewUrl = "/admin_contract_inside_preview.php";
              }
              common.cusHttp(
                this,
                previewUrl,
                { id: this.id },
                "get"
              ).then((previewRes) => {
                  Toast.clear();
                  let pRes = JSON.parse(previewRes.data);
                  if(pRes.errcode == 0){
                      window.open(pRes.url, "_blank");
                  } else {
                      common.mAlert(this, pRes.errmsg || "预览生成失败");
                  }
              }).catch(() => {
                  Toast.clear();
                  common.mAlert(this, "预览请求异常");
              });
           } else {
              Toast.clear();
              common.mAlert(this, res.errmsg || "保存失败");
           }
        })
        .catch(() => {
          Toast.clear();
          common.mAlert(this, "服务异常");
        });
    },


    // 生成预览
    previewContract() {
      this.saveContract(true)
    },

    // 提交合同
    submitContract(){

      console.log("提交合同")
      this.saveContract(false)
    },

    saveContract(isPreview = false) {
      //TODO 暂存草稿操作
      const confirmText = isPreview 
        ? '是否确认要生成合同预览？' 
        : '是否确认要提交合同？点确定表示你已仔细核对过填写内容。'
      
      Dialog.confirm({
        title: "操作提醒",
        message: confirmText,
      })
        .then(() => {
          // on confirm
          //TODO:清空
          // this.pay_username = '';
          // this.collection_username = '';
          // this.price = '';
          // this.pay_date = moment().format('YYYY-MM-DD')
          // this.attachment = '';

          //处理游客信息
          let _self = this;

          /** start of  产品信息和费用 **/
          if (!_self.contract_name) {
            common.mAlert(this, `线路名称不能为空`);
            return false;
          }

          if (!_self.course_data.length) {
            common.mAlert(this, `至少需要一位游客`);
            return false;
          }

          //还是要判断格式，就算存草稿也要正确格式的
          //遍历校验数据是否填写完全
          for (let i = 0, j = _self.course_data.length; i < j; i++) {
            if (!_self.course_data[i].name) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客姓名不能为空`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客姓名不能为空`);
              return false;
            }

            if (!_self.course_data[i].cardtype) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客证件类型不能为空`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客证件类型不能为空`);
              return false;
            }

            if (!_self.course_data[i].idcard) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客证件号不能为空`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客证件号不能为空`);
              return false;
            }

            //TDOO
            if (
              _self.course_data[i].cardtype == 1 &&
              !/(^\d{15}$)|(^\d{17}(x|X|\d)$)/.test(_self.course_data[i].idcard)
            ) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客身份证号格式异常`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客身份证号格式异常`);
              return false;
            }

            if (!_self.course_data[i].phone) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客手机号不能为空`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客手机号不能为空`);
              return false;
            }

            // /^1\d{10}$/

            if (!/^1\d{10}$/.test(_self.course_data[i].phone)) {
              //   _self.$notification['error']({
              //     message: '错误',
              //     description: '手机号格式异常',
              //     duration: 4,
              //   })
              common.mAlert(this, `第${i + 1}个游客手机号格式异常`);
              return;
            }

            if (!_self.course_data[i].is_child) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: "是否儿童不能为空",
              //     duration: 4,
              //   });
              common.mAlert(this, `是否儿童不能为空`);
              return false;
            }

            // if (i == 0) {
            //   if (!_self.course_data[i].address) {
            //     // _self.$notification["error"]({
            //     //   message: "错误",
            //     //   description: `游客代表地址不能为空`,
            //     //   duration: 4,
            //     // });
            //     common.mAlert(this, `游客代表地址不能为空`);

            //     return false;
            //   }
            // }
          }

          if (this.contract_type == "E00001") {
          } else {
            if (!_self.contract_begin_day) {
              common.mAlert(this, `出发日期不能为空`);
              return false;
            }

            if (!_self.contract_end_day) {
              common.mAlert(this, `结束日期不能为空`);
              return false;
            }

            if (!_self.contract_days) {
              common.mAlert(this, `天数不能为空`);
              return false;
            }

            if (_self.contract_nights === "") {
              common.mAlert(this, `夜晚数不能为空`);
              return false;
            }

            if (!_self.contract_adult_price) {
              common.mAlert(this, `成人价不能为空`);
              return false;
            }

            if (!_self.contract_child_price) {
              common.mAlert(this, `儿童价不能为空`);
              return false;
            }

            if (!_self.contract_service_price) {
              common.mAlert(this, `导游服务费不能为空`);
              return false;
            }

            if (!_self.contract_single_price) {
              common.mAlert(this, `单房差不能为空`);
              return false;
            }

            if (_self.contract_adult_count === "") {
              common.mAlert(this, `成人人数不能为空`);
              return false;
            }

            if (_self.contract_child_count === "") {
              common.mAlert(this, `儿童人数不能为空`);
              return false;
            }

            if (!_self.contract_price) {
              common.mAlert(this, `旅游费用不能为空`);
              return false;
            }

            if (!_self.contract_payway) {
              common.mAlert(this, `支付方式不能为空`);
              return false;
            }

            if (!_self.contract_pay_day) {
              common.mAlert(this, `支付时间不能为空`);
              return false;
            }

            /** end of 产品信息和费用 **/

            // console.log("游客信息输出");
            // console.log(_self.course_data);
            console.log("值都保存到这里了");

            if (!_self.contract_insurance_method) {
              common.mAlert(this, `意外伤害保险不能为空`);
              return false;
            }
            if (!_self.validateAutoInsuranceForSubmit()) {
              return false;
            }

            if (_self.contract_group_min_count === "") {
              common.mAlert(this, `最低成团人数不能为空`);
              return false;
            }

            if (!_self.contract_group_way) {
              common.mAlert(this, `不成团约定不能为空`);
              return false;
            }

            if (!_self.contract_group_agree) {
              common.mAlert(this, `拼团约定不能为空`);
              return false;
            }

            // if (!_self.contract_dispute_way) {
            //   common.mAlert(this, `争议解决方式不能为空`);
            //   return false;
            // }

            if (!_self.fileList.length) {
              common.mAlert(this, `附件不能为空`);
              return false;
            }
          }

          // 补齐签约人字段：第一个固定为 '1'，其他默认 '0'
          _self.course_data = _self.course_data.map(function(p, idx){
            var cloned = Object.assign({}, p);
            if (idx === 0) {
              cloned.isSigner = '1';
            } else if (typeof cloned.isSigner === 'undefined') {
              cloned.isSigner = '0';
            }
            return cloned;
          });

          // 处理出生日期格式：将 20001103 转换为 2000-11-03
          _self.course_data = this.processBirthdayFormat(_self.course_data);

          Toast.loading({
            duration: 0,
            mask: true,
            message: isPreview ? "预览生成中..." : "合同生成中...",
          });

          common
            .cusHttp(
              this,
              "/admin_user.php?action=add_or_modify_job_then_submit",
              {
                id: this.id,
                is_preview: isPreview ? 1 : 0,
                contract_begin_day: this.contract_begin_day,
                contract_end_day: this.contract_end_day,
                contract_begin_time: this.contract_begin_time,
                contract_end_time: this.contract_end_time,
                contract_pay_day: this.contract_pay_day,
                contract_name: this.contract_name,

                contract_adult_price: this.contract_adult_price,
                contract_child_price: this.contract_child_price,
                contract_adult_count: this.contract_adult_count,
                contract_child_count: this.contract_child_count,
                contract_price: this.contract_price,
                contract_pay_remark: this.contract_pay_remark,
                contract_payway: this.contract_payway,
                contract_service_price: this.contract_service_price,
                contract_single_price: this.contract_single_price,
                contract_days: this.contract_days,
                contract_nights: this.contract_nights,

                contract_insurance_method: this.contract_insurance_method,
                contract_entrust_type: this.contract_entrust_type,
                contract_insurance_productname:
                  this.contract_insurance_productname,
                contract_insurance_plan_code: this.contract_insurance_plan_code,
                contract_group_min_count: this.contract_group_min_count,
                contract_group_way: this.contract_group_way,
                contract_group_othername: this.contract_group_othername,
                contract_group_agree: this.contract_group_agree,
                contract_dispute_tribunalname:
                  this.contract_dispute_tribunalname,
                contract_dispute_way: 2,

                contract_person_json: JSON.stringify(_self.course_data),
                contract_person_count: _self.course_data.length,
                contract_main_phone: _self.course_data.length
                  ? _self.course_data[0].phone
                  : "",
                contract_main_name: _self.course_data.length
                  ? _self.course_data[0].name
                  : "",

                contract_attachment: JSON.stringify(_self.fileList),
                shoppings: JSON.stringify(this.shoppings),
                contract_plane:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.plane.getData(),
                contract_hotel:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.hotel.getData(),
                contract_car:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.car.getData(),
                contract_dao:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.dao.getData(),
                contract_visa:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.visa.getData(),
                contract_other:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.other.getData(),
                contract_rule:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.rule.getData(),

                local_travel_agency: JSON.stringify(this.local_travel_agency),
              },
              "post"
            )
            .then((res) => {
              //TODO 成功了跳转
              console.log("生产合同");
              console.log(res);
              Toast.clear();

              res = JSON.parse(res.data);
              if (res.errcode == 0) {
                const successMessage = isPreview ? "预览生成成功" : "合同生成成功"
                Dialog.alert({
                  title: "提示",
                  message: successMessage,
                }).then(() => {
                  // on close
                  if (!isPreview) {
                    this.$router.push({ path: "/" });
                  }
                });
              } else {
                common.mAlert(this, res.errmsg);
              }

              // common.mAlert(this, "暂存草稿成功");
              //   console.log("job_detail返回", res);
              //   res = JSON.parse(res.data);
              //   if (res.errcode == 0) {
              //     // this.static = res.data
              //     // console.log(JSON.stringify(res.data.loan_list));
              //     // this.list = res.data.loan_list;
              //     //   this.pending_list = res.result.data
              //     //   this.currentListLoading = false
              //     let info = res.data;
              //     this.info = info;

              //     this.contract_type = info.contract_type;
              //     console.log("输出Info");
              //     console.log(this.info);
              //   }
            });
        })
        .catch(() => {
          Toast.clear();
          // on cancel
          //返回上一页
          //   this.$router.push("/invoice");
          common.mAlert(this, "服务异常");
        });
    },

    showImage() {
      this.show = true;
    },
    goSms() {
      if (!/^1[0-9]\d{9}$/.test(this.mobile)) {
        this.$layer.msg("请输入正确的手机号");
        return;
      }

      if (!/^[0-4|6-9][0-9]{15,18}$/.test(this.account)) {
        common.mAlert(this, "请输入正确的银行卡号");
        return;
      }

      if (!this.mobile) {
        common.mAlert(this, "银行预留手机号不能为空");
        return;
      }

      if (this.second) {
        return;
      }

      this.second = 60;
      this.smsText = this.second + "秒";
      this.smsFlag = true;

      (function (a) {
        var countDownHandler = setInterval(function () {
          a.second = a.second - 1;
          if (a.second < 1) {
            clearInterval(countDownHandler);
            a.second = 0;
            a.smsText = "获取验证码";
            return;
          }
          a.smsText = a.second + "秒";
        }, 1000);
      })(this);

      this.$http
        .post(common.dynamicHost() + "/bor/bankcard", {
          id: this.id,
          mobile: this.mobile,
          bank_code: this.bank_code,
          account: this.account,
        })
        .then((res) => {
          if (res.data.status) {
            this.$layer.msg("发送成功");
          }
        })
        .catch((err) => {});
    },
    showBank() {
      common.setTitle("绑定还款银行卡");
      this.bankShow = true;
    },
    nextStep() {
      if (this.nextLock) {
        return;
      }

      if (this.invoiceType == -1) {
        common.mAlert(this, "发票类型不能为空");
        return;
      }

      if (!this.title) {
        common.mAlert(this, "发票抬头不能为空");
        return;
      }

      if (!this.taxpayer_number && this.invoiceType == 2) {
        common.mAlert(this, "请填写纳税人识别号");
        return;
      }

      // if ( !this.email )
      // {
      //     common.mAlert(this,'电子邮箱不能为空');
      //     return;
      // }

      //如果是企业开票的话，授权书是肯定不能少的哟
      if (this.invoiceType == 2 && !this.faceImg) {
        common.mAlert(this, "请上传企业开票授权书");
        return;
      }

      if (!this.price) {
        common.mAlert(this, "请输入金额");
        return;
      }

      if (!this.contract_no) {
        common.mAlert(this, "请输入合同号");
        return;
      }

      // location.href = 'status'
      /*加锁防止二次触发*/
      this.nextLock = true;
      common
        .cusHttp(
          this,
          "/api/save_invoice",
          {
            title: this.title,
            email: this.email,
            taxpayer_number: this.taxpayer_number,
            ids: this.chosenIds,
            type: this.invoiceType,
            shouquanshu: this.shouquanshu,
            taxpayer_phone: this.taxpayer_phone,
            bank_name: this.taxpayer_bank,
            bank_account: this.bank_account,
            taxpayer_address: this.taxpayer_address,
            price: this.price,
          },
          "post"
        )
        .then((res) => {
          this.nextLock = false;
          console.log(res);
          if (res.data.errcode == 0) {
            /**弹出confirm再录一笔，或者返回列表**/
            Dialog.confirm({
              title: "添加成功",
              message: "是否留在当前页面继续添加？",
            })
              .then(() => {
                // on confirm
                //TODO:清空
                // this.pay_username = '';
                // this.collection_username = '';
                // this.price = '';
                // this.pay_date = moment().format('YYYY-MM-DD')
                // this.attachment = '';
              })
              .catch(() => {
                // on cancel
                //返回上一页
                this.$router.push("/invoice");
              });
          } else {
            common.mAlert(this, res.data.errmsg);
          }
        })
        .catch((err) => {});
    },
    closeLayer: function () {
      this.layerFlag = false;
    },

    uploadImg() {
      this.$refs.filElem.dispatchEvent(new MouseEvent("click"));
    },
    initPage() {
      common
        .cusHttp(
          this,
          "/admin_user.php?action=job_detail",
          { id: this.id },
          "get"
        )
        .then((res) => {
          console.log("job_detail返回", res);
          res = JSON.parse(res.data);
          if (res.errcode == 0) {
            // this.static = res.data
            // console.log(JSON.stringify(res.data.loan_list));
            // this.list = res.data.loan_list;
            //   this.pending_list = res.result.data
            //   this.currentListLoading = false
            let info = res.data;
            this.info = info;

            this.contract_type = info.contract_type;
            this.contract_begin_day = info.contract_begin_day;
            this.contract_end_day = info.contract_end_day;
            this.contract_begin_time = info.contract_begin_time || "";
            this.contract_end_time = info.contract_end_time || "";
            this.contract_pay_day = info.contract_pay_day;
            this.contract_name = info.contract_name;

            this.contract_adult_price = info.contract_adult_price;
            this.contract_child_price = info.contract_child_price;
            this.contract_adult_count = info.contract_adult_count;
            this.contract_child_count = info.contract_child_count;
            this.contract_price = info.contract_price;
            this.contract_pay_remark = info.contract_pay_remark;
            this.contract_payway = info.contract_payway;

            this.contract_days = info.contract_days;
            this.contract_nights = info.contract_nights;

            this.contract_service_price = info.contract_service_price;
            this.contract_single_price = info.contract_single_price;

            this.contract_insurance_method = info.contract_insurance_method;
            // 转为字符串避免数字/字符串比较问题
            this.contract_entrust_type = String(info.contract_entrust_type || "");
            this.contract_insurance_plan_code =
              info.contract_insurance_plan_code || "";
            this.selectedPlanCode = info.contract_insurance_plan_code || "";
            this.contract_group_min_count = info.contract_group_min_count;

            // 根据委托方式加载产品名称，避免字段混用
            if (this.contract_entrust_type === '2') {
              // 自动委托：从产品对象获取名称，清空手动输入的产品名称
              this.contract_insurance_productname = "";
            } else {
              // 手动委托：使用手动输入的产品名称，清空自动委托相关字段
              this.contract_insurance_productname = info.contract_insurance_productname || "";
              this.contract_insurance_plan_code = "";
              this.selectedPlanCode = "";
            }

            // 如果是自动委托且有产品代码，预加载产品列表
            if (this.contract_insurance_method == '1' && this.contract_entrust_type == '2' && this.selectedPlanCode) {
              this.fetchInsuranceProducts();
            }
            this.contract_group_way = info.contract_group_way;

            this.contract_group_othername = info.contract_group_othername;
            this.contract_group_agree = info.contract_group_agree;
            this.contract_dispute_tribunalname =
              info.contract_dispute_tribunalname;
            this.contract_dispute_way = 2;

            // contract_insurance_method: this.contract_insurance_method,
            // contract_insurance_productname: this.contract_insurance_productname,
            // contract_group_min_count: this.contract_group_min_count,
            // contract_group_way: this.contract_group_way,
            // contract_group_othername: this.contract_group_othername,
            // contract_group_agree: this.contract_group_agree,
            // contract_dispute_tribunalname: this.contract_dispute_tribunalname,

            if (this.info.contract_person_json) {
              this.course_data = JSON.parse(this.info.contract_person_json);
              // 兼容历史数据：补齐 isSigner，且第一位固定为 '1'
              this.course_data = this.course_data.map(function(p, idx){
                var cloned = Object.assign({}, p);
                if (idx === 0) {
                  cloned.isSigner = '1';
                } else if (typeof cloned.isSigner === 'undefined') {
                  cloned.isSigner = '0';
                }
                return cloned;
              });
            }

            if (this.info.contract_attachment) {
              console.log("进来了");
              this.fileList = JSON.parse(this.info.contract_attachment);
            }
            // 初始化自愿购物
            if (this.info.shoppings) {
              try {
                this.shoppings = JSON.parse(this.info.shoppings) || [];
              } catch (e) {
                this.shoppings = [];
              }
            }

            // 初始化地接社信息
            if (this.info.local_travel_agency) {
              try {
                const agency = JSON.parse(this.info.local_travel_agency);
                this.local_travel_agency = {
                  agency_name: agency.agency_name || "",
                  agency_address_description: agency.agency_address_description || "",
                  contact_name: agency.contact_name || "",
                  contact_phone: agency.contact_phone || "",
                };
              } catch (e) {
                this.local_travel_agency = {
                  agency_name: "",
                  agency_address_description: "",
                  contact_name: "",
                  contact_phone: "",
                };
              }
            }

            //   contract_adult_price: this.contract_adult_price,
            // contract_child_price: this.contract_child_price,
            // contract_adult_count: this.contract_adult_count,
            // contract_child_count: this.contract_child_count,
            // contract_price: this.contract_price,
            // contract_pay_remark: this.contract_pay_remark,
            // contract_payway: this.contract_payway
            // contract_service_price: this.contract_service_price,
            // contract_single_price: this.contract_single_price
            console.log("输出Info");
            console.log(this.info);

            if (this.contract_type == "E00001") {
              this.$nextTick(() => {
                console.log("触发初始值设置");
                
                this.$refs.plane.init(this.info.contract_plane);
                this.$refs.hotel.init(this.info.contract_hotel);
                this.$refs.car.init(this.info.contract_car);
                this.$refs.dao.init(this.info.contract_dao);
                this.$refs.visa.init(this.info.contract_visa);
                this.$refs.other.init(this.info.contract_other);
                this.$refs.rule.init(this.info.contract_rule);
              });
            }
          }
        });
    },
  },
  created: function () {
    /**
     * 如果没有token则跳到登录页哟
     */
    common.checkToken(this);

    console.log("合同详情", this.id);
    this.initPage();
  },
  mounted() {
    // this.$store.commit("setTarbarIndex", 2);
  },
  computed: {
    showInsuranceMenu() {
      return (
        this.info.contract_insurance_batch_need_apply == 1 ||
        !!this.info.contract_insurance_plan_code
      );
    },
    nextStepValid: function () {
      return true;
    },
    facePath: function () {
      return common.dynamicHost() + this.faceImg;
    },
    images: function () {
      return [common.dynamicHost() + this.faceImg];
    },
    // 显示的产品名称
    // 自动委托：从保险产品列表中根据 plan_code 查找 plan_name
    // 手动委托：使用 contract_insurance_productname
    displayProductName() {
      if (this.contract_entrust_type === '2') {
        // 自动委托：从产品列表中查找对应的产品名称，找不到则显示code
        const planCode = this.selectedPlanCode || this.contract_insurance_plan_code;
        if (!planCode) return '';
        if (this.insuranceProducts.length > 0) {
          const product = this.insuranceProducts.find(p => p.plan_code === planCode);
          if (product) return product.plan_name;
        }
        // 列表未加载或找不到产品时，显示plan_code
        return planCode;
      } else {
        // 手动委托：显示手动输入的产品名称
        return this.contract_insurance_productname || '';
      }
    },
  },
};
</script>


<style>
html,
body {
  background-color: #f8f8f8 !important;
}

input::-webkit-input-placeholder {
  padding-top: 0;
  line-height: normal;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.inEdit {
  opacity: 0.4;
}

.disableText {
  color: #999999 !important;
}

.in-bl {
  display: inline-block;
}

.common-padding {
  padding: 0 0.625rem;
}
.common-padding2 {
  padding: 0.4rem 0.625rem;
}

.fc-aaaaaa-fs-nor-m {
  font-family: PingFangSC-Medium;
  font-size: 0.4375rem;
  color: #aaaaaa;
  line-height: 0.625rem;
}

.camera_text {
  line-height: 0.4rem;
  font-family: PingFangSC-Regular;
  font-size: 0.3rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #1889f9;
}

.bank-desc {
  font-family: PingFangSC-Regular;
  font-size: 0.438rem;
  color: #111111;
  line-height: 0.625rem;
}

.ps-text {
  font-size: 0.22rem;
  line-height: 0.3rem;
  color: #666666;
}

/* 保单弹层样式 - 紧凑版 */
.insurance-modal {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.insurance-modal-header {
  padding: 12px 16px 8px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.insurance-modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 8px;
}

.insurance-modal-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.insurance-cancel-switch {
  display: flex;
  align-items: center;
  gap: 6px;
}

.insurance-cancel-switch-label {
  font-size: 12px;
  color: #666;
}

.insurance-plan-hint {
  margin-top: 6px;
  font-size: 12px;
  color: #999;
}

.insurance-cancel-tip {
  margin-top: 6px;
  font-size: 12px;
  color: #ee0a24;
}

.insurance-batch-block {
  margin-bottom: 12px;
}

.insurance-batch-header {
  padding: 4px 0 8px;
  border-bottom: 1px dashed #eee;
  margin-bottom: 6px;
}

.insurance-batch-title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.insurance-batch-label {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.insurance-batch-order-no {
  margin-top: 4px;
  font-family: monospace;
  font-size: 11px;
  color: #999;
  word-break: break-all;
}

.insurance-modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 8px 12px;
  -webkit-overflow-scrolling: touch;
}

.insurance-modal-footer {
  padding: 8px 12px 12px;
  border-top: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.insurance-loading {
  text-align: center;
  padding: 40px;
}

.insurance-card {
  background: #fff;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  border: 1px solid #f0f0f0;
}

.insurance-card-main {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.insurance-left {
  flex: 1;
  min-width: 0;
}

.insurance-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  margin-left: 8px;
  flex-shrink: 0;
}

.insurance-person-name {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.insurance-meta {
  font-size: 12px;
  color: #666;
  margin-bottom: 3px;
  line-height: 1.4;
}

.insurance-meta-item {
  margin-right: 4px;
}

.insurance-policy-no {
  font-family: monospace;
  font-size: 11px;
  color: #999;
}


/* 1. 当没有选值时，强制 select 的文字显示为灰色 */
.placeholder-color {
  color: #999 !important; /* 或者你喜欢的灰色 */
}

/* 2. 重点：为了防止下拉菜单里的选项也变成灰色，
      我们需要显式定义 option 的颜色为黑色 */
.line-select option {
  color: #000;
  background-color: #fff;
}

/* 3. 针对某些旧版 iOS 的特殊处理 */
.line-select:invalid {
  color: #999;
}


.insurance-status-tag {
  display: inline-block;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 500;
}

.status-success {
  color: #07c160;
  background: rgba(7, 193, 96, 0.1);
  border: 1px solid rgba(7, 193, 96, 0.3);
}

.status-processing {
  color: #1989fa;
  background: rgba(25, 137, 250, 0.1);
  border: 1px solid rgba(25, 137, 250, 0.3);
}

.status-failed {
  color: #ee0a24;
  background: rgba(238, 10, 36, 0.1);
  border: 1px solid rgba(238, 10, 36, 0.3);
}

.status-cancelled {
  color: #ff976a;
  background: rgba(255, 151, 106, 0.1);
  border: 1px solid rgba(255, 151, 106, 0.3);
}

.status-default {
  color: #969799;
  background: rgba(150, 151, 153, 0.1);
  border: 1px solid rgba(150, 151, 153, 0.3);
}

.insurance-view-btn {
  font-size: 12px;
  padding: 5px 12px;
  background: linear-gradient(135deg, #07c160 0%, #05a050 100%);
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.2s;
}

.insurance-view-btn:active {
  opacity: 0.85;
}

.insurance-cancel-btn {
  font-size: 12px;
  padding: 5px 12px;
  background: #fff;
  color: #ee0a24;
  border: 1px solid #ee0a24;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
}

.insurance-cancel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.insurance-cancel-all-btn {
  margin-bottom: 8px;
}

.insurance-empty {
  text-align: center;
  padding: 60px 20px;
  color: #999;
}

.insurance-empty-icon {
  font-size: 48px;
  color: #ddd;
  margin-bottom: 12px;
}

.insurance-close-btn {
  font-size: 14px;
  height: 40px;
}

/* 产品选择器样式 */
.product-selector {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 8px 8px 0;
  min-height: 24px;
}

.product-selector .placeholder {
  color: #999;
  font-size: 14px;
}

.product-selector .selected-product {
  color: #333;
  font-size: 14px;
  flex: 1;
  max-width: 100%;
}

.product-selector .arrow-icon {
  color: #999;
  font-size: 16px;
  margin-left: 4px;
}

.product-selector.is-disabled {
  opacity: 0.55;
}

.product-selector.is-disabled .placeholder,
.product-selector.is-disabled .selected-product {
  color: #bbb;
}

.insurance-disclaimer-wrap {
  padding: 8px 12px 4px;
  text-align: left;
}

.insurance-disclaimer-label {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
}

.insurance-disclaimer-checkbox {
  flex-shrink: 0;
  margin-top: 3px;
  width: 16px;
  height: 16px;
}

.insurance-disclaimer-text {
  font-size: 12px;
  line-height: 1.6;
  color: #8c8c8c;
}

.product-card.is-disabled {
  opacity: 0.5;
  pointer-events: none;
}

/* 产品选择弹层样式 */
.product-popup {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f5f5f5;
}

.product-popup-header {
  flex-shrink: 0;
}

.product-popup-body {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  -webkit-overflow-scrolling: touch;
}

.product-loading {
  text-align: center;
  padding: 40px;
}

.product-card {
  background: #fff;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  border: 1px solid #ebedf0;
  position: relative;
}

.product-card.selected {
  border-color: #07c160;
  background: #f6ffed;
}

/* 主行：标题 + 价格/选择 */
.product-main-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 6px;
}

.product-title-wrap {
  flex: 1;
  min-width: 0;
}

.product-name {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
  margin-bottom: 4px;
}

.product-sub-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.product-supplier {
  font-size: 11px;
  color: #666;
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 3px;
}

.product-code {
  font-size: 11px;
  color: #999;
  font-family: monospace;
}

/* 右侧价格和选择 */
.product-action-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  margin-left: 10px;
}

.product-price {
  font-size: 14px;
  color: #ee0a24;
  font-weight: 600;
  white-space: nowrap;
}

.selected-icon {
  font-size: 20px;
}

.select-text {
  font-size: 13px;
  color: #07c160;
  font-weight: 500;
}

/* 底行：信息标签 + 查看详情 */
.product-bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 6px;
  border-top: 1px dashed #ebedf0;
}

.product-info {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
}

.info-tag {
  font-size: 11px;
  color: #666;
  background: #f7f8fa;
  padding: 2px 6px;
  border-radius: 3px;
}

.info-tag.highlight {
  color: #fa8c16;
  background: #fff7e6;
}

.detail-link {
  font-size: 12px;
  color: #1989fa;
  cursor: pointer;
  white-space: nowrap;
  margin-left: 8px;
}
</style>
